<ng-content select="top-bar"><!-- Top-bar --></ng-content>

@if (hasTopPanel) {
  <ng-content select="top-panel"></ng-content>
}
@if (hasLeftPanel || hasRightPanel) {
  <div class="panel-container">
    <ng-content select="left-panel"></ng-content>
    @if (!isMobile()) {
      <ng-content select="right-panel"></ng-content>
    }
  </div>
} @else {
  <ng-content></ng-content>
}
<ng-content select="bottom-bar"><!-- Top-bar --></ng-content>
